var instaSlider = document.querySelector(".category-slide");

if (instaSlider) {
  const splide = new Splide(instaSlider, {
      
    type: 'loop',
    perPage: 5.5,
    focus: 'center',
    perMove: 1,
    gap: '3rem',
    padding: '2rem',
    pagination: false,
    arrows: true,
    autoplay: true,
    speed: 500,
    interval: 1500,
    peek: { before: 50, after: 50 },
    autoScroll: false, // ✅ disables auto scroll
    breakpoints: {
      767: {
        grid: {
          rows: 2,
          cols: 1,
          gap: {
      row: '1rem',
      col: '1rem',
    },
        },
        perPage: 1,
        gap: '0',
        padding: '0',
        peek: { before: 0, after: 0 },
      },
      992: {
        perPage: 3,
        gap: '2rem',
        peek: { before: 30, after: 30 },
      },
      1440: {
        perPage: 4.5,
        gap: '2rem',
        peek: { before: 30, after: 30 },
      },
    },
  });

  splide.on('mounted', () => {
    if (instaSlider.querySelector('.splide__arrows')) {
      instaSlider.classList.add('has-arrows');
    }
  });

  splide.mount(window.splide.Extensions);
}


var customerSlider = document.querySelector(".customer-sayslide");
if (customerSlider) {
  const splide = new Splide(customerSlider, {
    type: 'loop',
    perPage: 1,
    perMove: 1,
    gap: '3rem',
    autoplay: false,
    interval: 1500,  // Change this value to speed up or slow down autoplay (in milliseconds)
    speed: 500,  
    pagination: false,
    arrows: true,
    autoScroll: false, // ✅ disables auto scroll
    breakpoints: {
      767: {
        grid: {
          rows: 2,
          cols: 1,
          gap: {
      row: '1rem',
      col: '1rem',
    },
        },
        autoplay: false,
       perPage: 1,
       focus: 'center',
       arrows: true,
      },
      992: {
        perPage: 1,
        gap: '2rem'
      },
    },
  });
  // Add has-arrows class after Splide is mounted
  splide.on('mounted', () => {
    if (customerSlider.querySelector('.splide__arrows')) {
      customerSlider.classList.add('has-arrows');
    }
  });
  // Mount the Splide instance
   splide.mount(window.splide.Extensions);
}

var customerpgSlider = document.querySelector(".customerpg-sayslide");
if (customerpgSlider) {
  const splide = new Splide(customerpgSlider, {
    type: 'loop',
    perPage: 3,
    perMove: 1,
    gap: '8rem',
     padding: '3rem',
    autoplay: false,
    interval: 1500,  // Change this value to speed up or slow down autoplay (in milliseconds)
    speed: 500,  
    pagination: false,
    arrows: true,
    autoScroll: false, // ✅ disables auto scroll
    focus: 'center',
    breakpoints: {
      767: {
        grid: {
          rows: 2,
          cols: 1,
          gap: {
      row: '1rem',
      col: '1rem',
    },
        },
        autoplay: false,
       perPage: 1,
       focus: 'center',
       arrows: true,
       padding: '0',
      },
      1199: {
        perPage: 1,
        gap: '2rem'
      },
    },
  });
  // Add has-arrows class after Splide is mounted
  splide.on('mounted', () => {
    if (customerpgSlider.querySelector('.splide__arrows')) {
      customerpgSlider.classList.add('has-arrows');
    }
  });
  // Mount the Splide instance
   splide.mount(window.splide.Extensions);
}

var shopby_videoSlider = document.querySelector(".video-collec");
if (shopby_videoSlider) {
  const splide = new Splide(shopby_videoSlider, {
    type: 'loop',
    perPage: 5,
    perMove: 1,
    gap: '2rem',
    pagination: false,
    arrows: true, // explicitly state arrows
    autoScroll: false, // ✅ disables auto scroll
 breakpoints: {
      640: {
        grid: {
          rows: 2,
          cols: 2,
          gap: {
      row: '1rem',
      col: '1rem',
    },
        },
        perPage: 1,
        gap: '1rem'
      },
      768: {
        perPage: 3,
        gap: '1rem'
      },
      1024: {
        perPage: 3,
        gap: '1.5rem'
      },
    },
  });
  // Add has-arrows class after Splide is mounted
  splide.on('mounted', () => {
    if (shopby_videoSlider.querySelector('.splide__arrows')) {
      shopby_videoSlider.classList.add('has-arrows');
    }
  });
  // Mount Splide
  splide.mount(window.splide.Extensions);
}

var product_videoSlider = document.querySelector(".productvideo-collec");
if (product_videoSlider) {
  const splide = new Splide(product_videoSlider, {
    type: 'loop',
    perPage: 4,
    perMove: 1,
    gap: '2.5rem',
    pagination: false,
    arrows: true, // explicitly state arrows
    autoScroll: false, // ✅ disables auto scroll
    breakpoints: {
      640: {
        grid: {
          rows: 2,
          cols: 2,
          gap: {
      row: '1rem',
      col: '1rem',
    },
        },
        perPage: 1,
        gap: '1rem'
      },
      768: {
        perPage: 3,
        gap: '1rem'
      },
      1024: {
        perPage: 3,
        gap: '1.5rem'
      },
    },
  });
  // Add has-arrows class after Splide is mounted
  splide.on('mounted', () => {
    if (product_videoSlider.querySelector('.splide__arrows')) {
      product_videoSlider.classList.add('has-arrows');
    }
  });
  // Mount Splide
  splide.mount(window.splide.Extensions);
}

var collection_videoSlider = document.querySelector(".collectionvideo-collec");
if (collection_videoSlider) {
  const splide = new Splide(collection_videoSlider, {
    type: 'loop',
    perPage: 4,
    perMove: 1,
    gap: '2.5rem',
    pagination: false,
    arrows: true, // explicitly state arrows
    autoScroll: false, // ✅ disables auto scroll
    breakpoints: {
      640: {
        grid: {
          rows: 2,
          cols: 2,
          gap: {
      row: '1rem',
      col: '1rem',
    },
        },
        perPage: 1,
        gap: '1rem'
      },
      768: {
        perPage: 3,
        gap: '1rem'
      },
      1024: {
        perPage: 3,
        gap: '1.5rem'
      },
    },
  });
  // Add has-arrows class after Splide is mounted
  splide.on('mounted', () => {
    if (collection_videoSlider.querySelector('.splide__arrows')) {
      collection_videoSlider.classList.add('has-arrows');
    }
  });
  // Mount Splide
  splide.mount(window.splide.Extensions);
}

var announcementSlider = document.querySelector(".availableonline-splide");

if (announcementSlider) {
  const splide = new Splide(announcementSlider, {
    type: 'loop', // must be loop for continuous scrolling
    drag: 'free', // allows smooth, continuous motion
    focus: 'center',
    pagination: false,
    arrows: false,
    perPage: 3.5,
    gap: '1rem',

    autoScroll: {
      speed: 1, // increase this for faster scrolling
      pauseOnHover: true,
      pauseOnFocus: false,
    },

    breakpoints: {
      359: {
        perPage: 1,
        gap: '1rem'
      },
      640: {
        perPage: 2,
        gap: '1rem'
      },
      768: {
        perPage: 3,
        gap: '1rem'
      },
      1024: {
        perPage: 3,
        gap: '1rem'
      },
    },
  });

  // ✅ Use Splide’s AutoScroll extension properly
  splide.mount(window.splide.Extensions || { AutoScroll: window.Splide.Extensions.AutoScroll });
}


var chooseSlider = document.querySelector(".choose-column");
if (chooseSlider) {
  const splide = new Splide(chooseSlider, {
    type: 'slide',
    //speed: 800,
    perPage: 3,
    perMove: 1,
    gap: '6.6rem',
    pagination: false,
    arrows: false,
    drag: false,
    breakpoints: {
      359: {
        perPage: 1,
        gap: '1rem'
      },
      640: {
        perPage: 1,
        gap: '1rem',  
      },
      767: {
        perPage: 1,
        gap: '1rem',
        arrows: true,
        drag: true,
        speed: 800,
      },
      1024: {
        perPage: 3,
        gap: '1.5rem'
      },
    },
  });
  // Add has-arrows class after Splide is mounted
  splide.on('mounted', () => {
    if (chooseSlider.querySelector('.splide__arrows')) {
      chooseSlider.classList.add('has-arrows');
    }
  });
  // Mount Splide
  splide.mount();

let hoverTimer = null;
splide.on('moved', function () {
  if (window.innerWidth > 767) {
    clearTimeout(hoverTimer);
    $('.splide__slide .choose-inner-both').removeClass('hovered');
    return;
  }
  clearTimeout(hoverTimer);
  $('.splide__slide .choose-inner-both').removeClass('hovered');
  const $active = $('.splide__slide.is-active .choose-inner-both');
  if (!$active.length) return;
  hoverTimer = setTimeout(function () {
    $active.addClass('hovered');
  }, 800);
});
}

var collection_listSlider = document.querySelector(".collection-list");
if (collection_listSlider) {
  const splide = new Splide(collection_listSlider, {
    type: 'slide',
    perPage: 3,
    perMove: 1,
    gap: '2rem',
    pagination: false,
    arrows: true, // explicitly state arrows
    autoScroll: false, // ✅ disables auto scroll
    breakpoints: {
      640: {
        grid: {
          rows: 1,
          cols: 1,
         
    //       gap: {
    //   row: '1rem',
    //   col: '1rem',
    // },
        },
        perPage: 1,
        gap: '1rem',
       arrows: true,
      },
      768: {
        perPage: 3,
        gap: '1rem'
      },
      1024: {
        perPage: 3,
        gap: '1.5rem'
      },
    },
  });
  // Add has-arrows class after Splide is mounted
  splide.on('mounted', () => {
    if (collection_listSlider.querySelector('.splide__arrows')) {
      collection_listSlider.classList.add('has-arrows');
    }
  });
  // Mount Splide
  splide.mount(window.splide.Extensions);
}

var productmSlider = document.querySelector(".productmediaslide");
if (productmSlider) {
  const splide = new Splide(productmSlider, {
    type: 'loop',
    perPage: 2,
    perMove: 1,
    gap: '3rem',
    autoplay: true,
    interval: 2000,  // Change this value to speed up or slow down autoplay (in milliseconds)
    speed: 1000,  
    pagination: false,
    arrows: false,
    autoScroll: false, // ✅ disables auto scroll
    breakpoints: {
      767: {
        
       perPage: 2,
       
      
      },
      992: {
        perPage: 2,
        gap: '2rem'
      },
    },
  });
  // Add has-arrows class after Splide is mounted
  splide.on('mounted', () => {
    if (productmSlider.querySelector('.splide__arrows')) {
      productmSlider.classList.add('has-arrows');
    }
  });
  // Mount the Splide instance
   splide.mount(window.splide.Extensions);
}

document.addEventListener('DOMContentLoaded', function() {
  const recipeTypeFilter = document.getElementById('filter-recipe-type');
  const cookingTimeFilter = document.getElementById('filter-cooking-time');
  const ingredientsFilter = document.getElementById('filter-ingredients');
  const clearBtn = document.getElementById('clear-filters');
  const recipes = document.querySelectorAll('.recipe-repeat');

  function filterRecipes() {
    const selectedType = recipeTypeFilter.value;
    const selectedTime = cookingTimeFilter.value;
    const selectedIngredient = ingredientsFilter.value;

    recipes.forEach(card => {
      const typeMatch = !selectedType || card.dataset.recipeType === selectedType;
      const timeMatch = !selectedTime || card.dataset.cookingTime === selectedTime;
      const ingredientMatch = !selectedIngredient || card.dataset.ingredients === selectedIngredient;

      card.style.display = (typeMatch && timeMatch && ingredientMatch) ? '' : 'none';
    });
  }

  recipeTypeFilter.addEventListener('change', filterRecipes);
  cookingTimeFilter.addEventListener('change', filterRecipes);
  ingredientsFilter.addEventListener('change', filterRecipes);

  clearBtn.addEventListener('click', () => {
    recipeTypeFilter.value = '';
    cookingTimeFilter.value = '';
    ingredientsFilter.value = '';
    recipes.forEach(card => card.style.display = '');
  });
});

const btn = document.getElementById('scrollTop');

  // Show/hide button
  window.addEventListener('scroll', () => {
    if (window.scrollY > 250) btn.classList.add('show');
    else btn.classList.remove('show');
  });

  // Scroll to top using native smooth behavior
  btn.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  




$('.choose-inner-both').hover(
  function() {
    // Mouse enters: add class
    $(this).addClass('hovered');
  },
  function() {
    // Mouse leaves: remove class
    $(this).removeClass('hovered');
  }
);


// $('.choose-column .splide__arrow').on('click', function() {
//   $('.is-active .choose-inner-both').trigger('click');
// });

// $(document).on('click', '.is-active .choose-inner-both', function() {
//   var $this = $(this); 
//     $(".choose-inner-both").removeClass("hovered");
//   setTimeout(function() {
//     $this.addClass('hovered');
//   }, 3000);

// });

// let hoverTimer;

// splide.on('moved', function () {
//   const $active = $('.splide__slide.is-active .choose-inner-both');
//   $('.choose-inner-both').removeClass('hovered');
//   clearTimeout(hoverTimer);

//   hoverTimer = setTimeout(function () {
//     $active.addClass('hovered');
//   }, 1500);
// });
